import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { establishAssetSession, refreshAccessToken } from "../../services/authService";
import { getItem, hasValidAuth, logout, hasDomain } from "../../utils/authStorage";
import { isTokenExpired, tokenExpiresWithin } from "../../utils/jwtDecoder";
import LoadingSpinner from "./LoadingSpinner";
import Chatbot from "../chatbot";

// The asset cookie lives as long as the access token; refresh ahead of expiry
// so images/tiles/video keep loading on pages that make no API calls.
const PROACTIVE_REFRESH_MS = 3 * 60 * 1000;
const REFRESH_CHECK_INTERVAL_MS = 60 * 1000;

export const ProtectedRoute = ({ children }) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      const token = getItem('accessToken');
      if (token && isTokenExpired(token)) {
        try {
          await refreshAccessToken();
        } catch {
          logout();
          return;
        }
      }
      if (getItem('accessToken')) {
        try {
          await establishAssetSession();
        } catch (error) {
          console.warn('Asset session could not be established:', error);
        }
      }
      setIsReady(true);
    };
    init();

    const timer = setInterval(() => {
      const token = getItem('accessToken');
      if (token && tokenExpiresWithin(token, PROACTIVE_REFRESH_MS)) {
        refreshAccessToken().catch(() => {});
      }
    }, REFRESH_CHECK_INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  if (!hasValidAuth()) {
    return <Navigate to="/login" replace />;
  }

  if (!isReady) {
    return <LoadingSpinner message="Authenticating..." />;
  }

  // Chatbot is only available in the Construction domain
  const showChatbot = hasDomain('construction');

  return (
    <>
      {children}
      {showChatbot && <Chatbot />}
    </>
  );
};
